import { makeStyles } from "tss-react/mui";
import { constants } from "../../constants";

interface IStyles {
    backgroundImage?: string | null;
}
export const useStyles = makeStyles<IStyles>()(
    (theme, { backgroundImage }) => ({
        root: {
            width: "100%",
            maxWidth: constants.dimensions.maxWidth,
            minHeight: "816px",
            backgroundColor: constants.color.white,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "71px",
            padding: "120px 0",

            "&.right": {
                flexDirection: "row-reverse",
            },
            "&.with-background": {
                backgroundImage: `url(${backgroundImage})`,
                backgroundColor: constants.color.black,
                gap: "72px",
                backgroundSize: "cover",
            },
            "&.hero": {
                backgroundColor: constants.color.black,
                marginTop: "-220px",
                transformOrigin: "bottom center",
                transform: "scale(0.85) translateY(140px)",
                // NOTE: Animation for Hero is located in PromptAnimations
            },
        },
        outer: {
            backgroundColor: constants.color.white,
        },
        imageContainer: {
            display: "flex",
            width: "100%",
            maxWidth: "475px",
            height: "100%",
            maxHeight: "596px",

            "&.with-background": {
                backgroundImage: `url(${backgroundImage})`,
                boxShadow: `inset black`,
            },

            "& img": {
                width: "100%",
                objectFit: "cover",
            },
        },
        infoContainer: {
            display: "flex",
            flexDirection: "column",
            width: "660px",
            position: "relative",
            color: constants.color.black,
            "&.full-background": {
                width: "637px",
                color: constants.color.white,
                "& .favorite-icon img": {
                    filter: "invert(1)",
                },
            },

            "& .favorite-icon": {
                position: "absolute",
                top: "2.75px",
                right: "3px",
                width: "28px",

                "& img": {
                    objectFit: "cover",
                },
            },

            "&.hero": {
                color: constants.color.white,
            },
        },

        infoDescription: {
            display: "flex",
            flexDirection: "column",
            marginBottom: "48px",
            "& .product-tagline": {
                fontFamily: "Gotham book",
                fontWeight: 450,
                fontSize: "68px",
                lineHeight: "76px",
                letterSpacing: "2px",
                marginBottom: "34px",
                textTransform: "uppercase",
            },
            "& .product-description": {
                fontFamily: "Galaxie Copernicus",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "26px",
            },
        },
        infoCommercial: {
            display: "flex",
            flexDirection: "column",
            marginBottom: "24px",
            "& .product-eyebrow": {
                fontFamily: "Gotham book",
                fontWeight: 410,
                fontSize: "12px",
                lineHeight: "20px",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
            },
            "& .product-name-price": {
                display: "flex",
                flexDirection: "row",
                justifyContent: "left",
                "& .product-name": {
                    fontFamily: "Gotham book",
                    fontWeight: 450,
                    fontSize: "14px",
                    lineHeight: "24px",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                },
                "& hr": {
                    width: "14px",
                    height: "2px",
                    margin: "auto 12px auto 12px",
                    color: constants.color.alizarin,
                    backgroundColor: constants.color.alizarin,
                    display: "inline",
                    border: 0,
                },
                "& .product-price": {
                    fontFamily: "Gotham book",
                    fontWeight: 410,
                    fontSize: "14px",
                    lineHeight: "25px",
                    letterSpacing: "3px",
                    textTransform: "uppercase",
                },
            },
        },
        infoCta: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "left",
            "& .cta-link": {
                fontFamily: "Gotham book",
                fontWeight: 450,
                fontSize: "12px",
                lineHeight: "18px",
                letterSpacing: "1px",
                textTransform: "uppercase",
                borderBottom: `1px solid ${constants.color.alizarin}`,
                paddingBottom: "3px",
                width: "fit-content",
                color: constants.color.black,
                ".with-background &": {
                    color: constants.color.white,
                },
            },
            "& .cta-button": {
                width: "264px",
                height: "55.59px",
                backgroundColor: constants.color.white,
                marginBottom: "16px",
                "&.MuiButtonBase-root": {
                    fontFamily: "Gotham book",
                    fontWeight: 410,
                    fontSize: "12px",
                    lineHeight: "20px",
                    letterSpacing: "1.5px",
                    textTransform: "uppercase",
                    color: constants.color.black,
                    borderRadius: 0,
                },
            },
        },
    })
);
